module.exports = __webpack_public_path__ + "img/reactNative.7be8b524.svg";